"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRIP_DATE_PAST_LIMIT_YEARS = exports.TRIP_DATE_FUTURE_LIMIT_YEARS = exports.TRIP_MAXIMUM_DURATION_DAYS = void 0;
exports.TRIP_MAXIMUM_DURATION_DAYS = 90;
exports.TRIP_DATE_FUTURE_LIMIT_YEARS = 2;
exports.TRIP_DATE_PAST_LIMIT_YEARS = 3;
